import { useLocalSearchParams } from 'expo-router';

import { MeetingDetailPage } from '@/components';

const MeetingDetailRoute = () => {
  const { id, openAttendeePicker } = useLocalSearchParams<{
    id: string;
    openAttendeePicker?: string;
  }>();

  return id ? (
    <MeetingDetailPage id={id} initialPickerVisible={openAttendeePicker === 'true'} />
  ) : null;
};

export default MeetingDetailRoute;
